import { get } from '@rails/request.js'

export async function openMiniFast(url, options = {}) {
  await loadMiniFastModal(url)
  openMiniFastModal(options)
}

export async function loadMiniFastModal(url = null) {
  if (document.querySelector('#mini-fast')) return

  const response = await get(url || '/projects/new', { responseKind: 'html' })
  if (response.ok) {
    const html = await response.html
    document.body.insertAdjacentHTML('beforeend', html)
  }
}

export function openMiniFastModal(options = {}) {
  const modal = document.querySelector('#mini-fast')

  if (!modal) {
    console.error('No fast modal found')
    return
  }

  $(modal).modal('show')

  const input = modal.querySelector("input[name='project[name]']")
  if (input && options.prefilledProjectTitle) {
    input.value = options.prefilledProjectTitle
  }

  if (options.invitedProvider) {
    modal.querySelector("input[name='user_slug']").value = options.invitedProvider.slug
  }
}
